var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOvhcloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5005 11.7092C36.6343 17.3422 36.0393 24.3239 32.0327 29.3619H23.5039L26.122 24.7206H22.6708L26.7567 17.5405H30.2476L33.5005 11.7092ZM16.7205 29.3619H8.03298C3.94707 24.3239 3.35203 17.3025 6.52555 11.6695L12.1586 21.4281L18.3469 10.6381H27.4708L16.7205 29.3619Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOvhcloud);
export default __webpack_public_path__ + "static/media/ovhcloud.69bac97608cce2d14c5e8ad39e84a638.svg";
export { ForwardRef as ReactComponent };